var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Grid, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AutoCompleteDD from '../../components/FormComponents/AutoCompleteDD';
import MUIDatePicker from '../../components/FormComponents/DatePicker';
import { DatePickerWrapper } from './Backlog';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { utility } from '../../utils';
import constants from '../../config/constants';
import moment from 'moment';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { TruncatedTooltipText } from '../../components/uiComponents/TruncatedTooltipText';
import TabSectionCard, { DataWrapper } from './components/TabSectionCard';
import { RESPONSIVE_FIELD_GRID_SX } from './utils/responsiveGrid';
var EFTAssignment = function (_a) {
    var _b, _c, _d, _e;
    var TxAspireOId = _a.TxAspireOId, appMetaData = _a.appMetaData, _roleType = _a.roleType, hasEditAccess = _a.hasEditAccess, _onDataRefresh = _a.onDataRefresh, onEditModeChange = _a.onEditModeChange;
    var _f = useState(false), isEditMode = _f[0], setIsEditMode = _f[1];
    React.useEffect(function () {
        if (onEditModeChange) {
            onEditModeChange(isEditMode);
        }
    }, [isEditMode, onEditModeChange]);
    var _g = useState([]), eftBank = _g[0], setEftBank = _g[1];
    var _h = useState(false), openSaveDialog = _h[0], setOpenSaveDialog = _h[1];
    var eftBankObj = eftBank && eftBank.length ? eftBank[0] : {};
    var getEFTBankInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    payload = { TxAspireOId: TxAspireOId };
                    return [4, api_service.get({
                            endPoint: api_urls.GET_EFT_BANK,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 1:
                    response = _c.sent();
                    if (response.data && response.data.statusCode === 200) {
                        setEftBank(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) || []);
                    }
                    else {
                        utility.alert((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message, constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 3];
                case 2:
                    error_1 = _c.sent();
                    utility.alert(error_1, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    useEffect(function () {
        if (TxAspireOId) {
            getEFTBankInfo();
        }
    }, [TxAspireOId]);
    var getDropdownOptions = function (type) {
        var _a, _b;
        if (!appMetaData)
            return [];
        switch (type) {
            case 'banks':
                return (_b = (_a = appMetaData === null || appMetaData === void 0 ? void 0 : appMetaData.EFTBanks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                    Name: item.Description,
                    OId: item.EFTBankOId,
                }); })) !== null && _b !== void 0 ? _b : [];
            case 'accountNumber':
                return (eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.AccountNumber) ? [{ Name: eftBankObj.AccountNumber }] : [];
            default:
                return [];
        }
    };
    var getSelectedDropdownValue = function (dropdownValue, type) {
        var _a;
        if (!dropdownValue || !appMetaData)
            return '';
        if (type === 'banks') {
            var found = (_a = appMetaData.EFTBanks) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.EFTBankOId === dropdownValue; });
            return found ? { OId: found.EFTBankOId, Name: found.Description } : '';
        }
        else if (type === 'accountNumber') {
            var found = (eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.AccountNumber) === dropdownValue;
            return found ? { OId: '', Name: eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.AccountNumber } : '';
        }
        return '';
    };
    return (React.createElement(Stack, { gap: 2 },
        React.createElement(TabSectionCard, { title: "EFT Assignment", showEditIcon: false, onEditClick: function () { return setIsEditMode(true); }, showSaveCancel: isEditMode, onSave: function () { return setOpenSaveDialog(true); }, onCancel: function () { return setIsEditMode(false); } },
            React.createElement(Grid, { container: true, spacing: 2, alignItems: "end", sx: RESPONSIVE_FIELD_GRID_SX },
                React.createElement(Grid, { item: true, xs: 4 }, isEditMode ? (React.createElement(AutoCompleteDD, { options: getDropdownOptions("accountNumber"), displayKey: "Name", valueKey: "OId", label: "Account Number:", placeholder: "Select Account Number", noOptionsText: "No Options", handleChange: function () { }, selectedValue: (eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.AccountNumber) != null ? getSelectedDropdownValue(eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.AccountNumber, 'accountNumber') : '', name: "AccountNumber", isMandatoryField: false, handleBlur: function () { }, fontWeight: "600" })) : (React.createElement(DataWrapper, { gap: 1 },
                    React.createElement(Typography, { variant: "caption", className: "title" }, "Account Number:"),
                    React.createElement(TruncatedTooltipText, { value: (_b = eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.AccountNumber) !== null && _b !== void 0 ? _b : '--' })))),
                React.createElement(Grid, { item: true, xs: 4 }, isEditMode ? (React.createElement(AutoCompleteDD, { options: getDropdownOptions("banks"), displayKey: "Name", valueKey: "OId", label: "Originating Bank:", placeholder: "Select Bank", noOptionsText: "No Options", handleChange: function () { }, selectedValue: (eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.EFTBankOId) != null ? getSelectedDropdownValue(eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.EFTBankOId, 'banks') : '', name: "OriginatingBank", isMandatoryField: false, handleBlur: function () { }, fontWeight: "600" })) : (React.createElement(DataWrapper, { gap: 1 },
                    React.createElement(Typography, { variant: "caption", className: "title" }, "Originating Bank:"),
                    React.createElement(TruncatedTooltipText, { value: (_c = eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.OriginatingBank) !== null && _c !== void 0 ? _c : '--' })))),
                React.createElement(Grid, { item: true, xs: 4 }, isEditMode ? (React.createElement(DatePickerWrapper, null,
                    React.createElement(MUIDatePicker, { labelText: "EFT Parameters Start Date:", isMandatory: false, selectedDate: (_d = eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.EFTParametersStartDate) !== null && _d !== void 0 ? _d : "", dateChangeHandler: function () { }, fontWeight: "600", clearDate: function () { } }))) : (React.createElement(DataWrapper, { gap: 1 },
                    React.createElement(Typography, { variant: "caption", className: "title" }, "EFT Parameters Start Date:"),
                    React.createElement(TruncatedTooltipText, { value: (eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.EFTParametersStartDate) ? moment(eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.EFTParametersStartDate).format('YYYY-MM-DD') : '--' })))),
                React.createElement(Grid, { item: true, xs: 4 },
                    React.createElement(DataWrapper, { gap: 1 },
                        React.createElement(Typography, { variant: "caption", className: "title" }, "Bank Name:"),
                        React.createElement(TruncatedTooltipText, { value: (_e = eftBankObj === null || eftBankObj === void 0 ? void 0 : eftBankObj.BankName) !== null && _e !== void 0 ? _e : '--' }))))),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: "Save Changes", message: "Would you like to save the changes you've made?", acceptBtnText: "Yes", denyBtnText: "No", open: openSaveDialog, acceptCallBack: function () { setIsEditMode(false); setOpenSaveDialog(false); }, denyCallBack: function () { return setOpenSaveDialog(false); }, cancelCallBack: function () { return setOpenSaveDialog(false); } })));
};
export default EFTAssignment;
